import { render, staticRenderFns } from "./WidgetReviewsHorizontalScrollMobile.vue?vue&type=template&id=f87c5252"
import script from "./WidgetReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports